// FloatingWindowModal.jsx
import React from "react";
import {
    Box,
    Modal,
    Typography,
    IconButton,
    useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import ocpsLogo from "../../assets/ocps_logo.png"; // Replace with actual OCPS logo path
import figLogo from "../../assets/fig_CROP.png"; // Replace with actual FIG logo path

const FloatingWindowContainer = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: "16px",
    width: "400px",
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    outline: "none",
}));

const Logo = styled("img")({
    width: "100px",
    height: "100px",
    marginBottom: "16px",
});

const FloatingWindowModal = ({ open, onClose, content }) => {
    const theme = useTheme();

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="floating-window-title"
            aria-describedby="floating-window-description"
        >
            <FloatingWindowContainer>
                {/* Close Button */}
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: "8px",
                        right: "8px",
                        color: theme.palette.grey[600],
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* OCPS Logo */}
                <Logo src={ocpsLogo} alt="OCPS Logo" />

                {/* Content */}
                <Typography
                    id="floating-window-title"
                    variant="h6"
                    sx={{ marginBottom: 2, textAlign: "center" }}
                >
                    {content.title || "Modal Title"}
                </Typography>

                <Typography
                    id="floating-window-description"
                    variant="body1"
                    sx={{ marginBottom: 4, textAlign: "center" }}
                >
                    {content.description || "Modal Description"}
                </Typography>

                {/* FIG Logo */}
                <Logo src={figLogo} alt="FIG Logo" />
            </FloatingWindowContainer>
        </Modal>
    );
};

export default FloatingWindowModal;
